import { detectLanguage } from '@tsl-frontend/tsl-locale';

import { appConfigRegistry } from './appConfigRegistry';

export const regionAppConfig = appConfigRegistry[detectLanguage()];
